import * as React from "react";
import { IndividualEmploymentStatus } from "../../../../../../Wrap/Constants/Enums/Domain/IndividualEmploymentStatus";
import { InvestorType } from "../../../../../../Wrap/Constants/Enums/Domain/InvestorType";
import { ContentDatePicker, ACCEPT_DATE_FORMATS } from "../../../../../Shared/Entities/Constants/DateConstants";
import { Frequency } from "../../../../../../Wrap/Constants/Enums/Domain/Frequency";

export const quoteSteppersMap = {
    wrapperSelection: "Wrapper selection",
    paymentsIn: "Payments in",
    adviserCharges: "Adviser charges",
    investment: "Investment selection",
    drawdownDetails: "Drawdown details",
    incomePaymentDetails: "Income payment details",
    quoteReady: "Quote ready",
    withdrawal: "Withdrawals",
    SIPP: "Aberdeen SIPP",
    ISA: "ISA Stocks & Shares",
    PP: "Personal Portfolio",
    JSIPP: "Junior SIPP",
};

export const IndividualEmploymentStatusOptions = [
    IndividualEmploymentStatus.Carer,
    IndividualEmploymentStatus.Employed,
    IndividualEmploymentStatus.Homemaker,
    IndividualEmploymentStatus.NotApplicable,
    IndividualEmploymentStatus.Retired,
    IndividualEmploymentStatus.SelfEmployed,
    IndividualEmploymentStatus.Student,
    IndividualEmploymentStatus.Unemployed,
];

export const IndividualEmploymentStatusOptionsMap = {
    [IndividualEmploymentStatus.Carer]: "Carer",
    [IndividualEmploymentStatus.Employed]: "Employed",
    [IndividualEmploymentStatus.Homemaker]: "Homemaker",
    [IndividualEmploymentStatus.NotApplicable]: "Not Applicable",
    [IndividualEmploymentStatus.Retired]: "Retired",
    [IndividualEmploymentStatus.SelfEmployed]: "Self Employed",
    [IndividualEmploymentStatus.Student]: "Student",
    [IndividualEmploymentStatus.Unemployed]: "Unemployed",
};

export const EmploymentRole = [
    "Accountant",
    "Administrative Occupations: Finance",
    "Administrative Occupations: Government and Related Organisations",
    "Administrative Occupations: Office Managers and Supervisors",
    "Administrative Occupations: Records",
    "Agricultural and Related Trades",
    "Animal Care and Control Services",
    "Architects, Chartered Architectural Technologists, Planning Officers, Surveyors and Construction Professionals",
    "Armed Services",
    "Artistic, Literary and Media Occupations",
    "Assemblers and Routine Operatives",
    "Bed and Breakfast and Guest House Owners and Proprietors",
    "Building Finishing Trades",
    "Business and Financial Project Management Professionals",
    "Business Analyst",
    "Business Associate Professionals",
    "Business, Research and Administrative Professionals",
    "CAD, Drawing and Architectural Technicians",
    "Call handler",
    "Caring Personal Services",
    "Chief Executives and Senior Official",
    "Civil Services",
    "Cleaning and Housekeeping Managers and Supervisors",
    "Clergy ",
    "Community and Civil Enforcement Occupations",
    "Conservation and Environment Professionals",
    "Construction and Building Trades",
    "Construction and Building Trades Supervisors",
    "Construction Operatives",
    "Customer Service Occupations",
    "Customer Service Supervisors",
    "Design Occupations",
    "Directors in Logistics, Warehousing and Transport",
    "Electrical and Electronic Trades",
    "Electrician",
    "Elementary Administration Occupations",
    "Elementary Agricultural Occupations",
    "Elementary Cleaning Occupations",
    "Elementary Construction Occupations",
    "Elementary Process Plant Occupations",
    "Elementary Sales Occupations",
    "Elementary Security Occupations",
    "Elementary Storage Occupations",
    "Emergency Services",
    "Engineering Professionals",
    "Finance Associate Professionals",
    "Finance Professionals",
    "Financial Consultant",
    "Food Preparation and Hospitality Trades",
    "Functional Managers and Directors",
    "Gardener ",
    "Government Official",
    "Hairdressers and Related Services",
    "Health and Social Services Managers and Directors",
    "Health Associate Professionals",
    "Housekeeping and Related Services",
    "HR, Training and Other Vocational Associate Guidance Professionals",
    "Independent Financial Adviser",
    "Information Technology Professionals",
    "Information Technology Technicians",
    "Joiner",
    "Lecturer",
    "Legal Associate Professionals",
    "Legal Professionals",
    "Leisure and Travel Services",
    "Librarians and Related Professionals",
    "Managers and Directors in Retail and Wholesale",
    "Managers and Proprietors in Agriculture Related Services",
    "Managers and Proprietors in Health and Care Services",
    "Managers and Proprietors in Hospitality and Leisure Services",
    "Managers and Proprietors in Other Services",
    "Managers in Logistics, Warehousing and Transport",
    "Media Professionals",
    "Medical Practitioners",
    "Metal Forming, Welding and Related Trades",
    "Metal Machining, Fitting and Instrument Making Trades",
    "Metal Working Machine Operatives",
    "Military",
    "Mobile Machine Drivers and Operatives",
    "Natural and Social Science Professionals",
    "Not Applicable",
    "Nursing Professionals",
    "Other Administrative Occupations",
    "Other Drivers and Transport Operatives",
    "Other Educational Professionals",
    "Other Elementary Services Occupations",
    "Other Health Professionals",
    "Other Skilled Trades",
    "Plant and Machine Operatives",
    "Plumber",
    "Printing Trades",
    "Process Operatives",
    "Production Managers and Directors",
    "Production, Factory and Assembly Supervisors",
    "Property Consultant",
    "Protective Service Occupations",
    "Public Services Associate Professionals",
    "Quality and Regulatory Professionals",
    "Recruiter",
    "Regulatory Associate Professionals",
    "Research and Development (R&D) and Other Research Professionals",
    "Road Transport Drivers",
    "Sales Assistants and Retail Cashiers",
    "Sales Related Occupations",
    "Sales, Marketing and Related Associate Professionals",
    "Sales, Marketing and Related Associate Professionals - Estate agents and auctioneers",
    "Science, Engineering and Production Technicians",
    "Secretarial and Related Occupations",
    "Senior Officers in Protective Services",
    "Shopkeepers and Sales Supervisors",
    "Skilled Metal, Electrical and Electronic Trades Supervisors",
    "Sports and Fitness Occupations",
    "Teaching and Childcare Associate Professionals",
    "Teaching and Childcare Support Occupations",
    "Teaching Professionals",
    "Textiles and Garments Trades",
    "Therapy Professionals",
    "Transport Associate Professionals",
    "Vehicle Trades",
    "Veterinarians",
    "Veterinary nurses",
    "Web and Multimedia Design Professionals",
    "Welfare and Housing Associate Professionals",
    "Welfare Professionals",
];

export const PersonalPortfolioTypesArray = [InvestorType.Single, InvestorType.Joint];

export const PersonalPortfolioTypesMap = {
    [InvestorType.Single]: "Single",
    [InvestorType.Joint]: "Joint",
};

export const FrequencyTypeArrays = [Frequency.Monthly, Frequency.Quarterly, Frequency.HalfYearly, Frequency.Yearly];

export const FrequencyArraysMap = {
    [Frequency.Monthly]: "Monthly",
    [Frequency.Quarterly]: "Quarterly",
    [Frequency.HalfYearly]: "Half yearly",
    [Frequency.Yearly]: "Yearly",
};

// Temporary until Drawdown details coded
export enum DrawdownType {
    Other = 0,
    RegularCrystallisation = 1,
    FlexiAccessRegular = 2,
}

export const datePickerOptions = {
    showYearDropdown: true,
    todayButton: ContentDatePicker.Today,
    isClearable: true,
    dateFormat: ContentDatePicker.DateFormat,
    acceptDateFormats: ACCEPT_DATE_FORMATS,
};

export const daysUntilFirstPaymentDate = 20;

export const quoteSippIncomePaymentDetailsLabels = {
    regularIncomePayment: "Regular Income Payment",
    taxableIncomeRequiredInAddition: "Is taxable income required in addition to the tax-free lump sum?",
    targetSpecificArrangements: "Do you wish to target specific arrangements?",
    targetSpecificArrangementsTooltip: "Where a customer has more than one drawdown arrangement, you are able to choose which arrangements are used to provide income withdrawals. Selecting specific arrangements can be beneficial for clients who have inherited drawdown benefits which have different tax treatments. Or you can select 'No' and the platform will automatically choose the arrangements to be used.",
    takeDifferentInitialIncomePaymentTooltip: "We offer a different initial income payment; this could be used to take a one-off taxable withdrawal or an alternative first payment followed by a regular income payment of a different amount.",
    takeDifferentInitialIncomePayment: "Do you wish to take a different initial income payment?",
    grossInitialIncomePayment: "Gross initial income payment",
    maximumInitialIncomePayment: "Maximum for initial income payment",
    maximumIncomePerPayment: "Maximum income per payment",
    maximumAvailablePerPayment: "Maximum available per payment",
    grossIncomePerPayment: "Gross income per payment",
    grossIncomePerPaymentFromPension: "Gross income per payment from the pension",
    incomeFrequency: "Income frequency",
    nextFlexiIncomeReviewDate: "Next flexible income review date",
    frequencyOfFlexiIncomeReview: "Frequency of flexible income review",
    firstPaymentDate: "First payment date",
    endDate: "End date",
    untilNotified: "Until notified",
    enterADate: "Enter a date",
    calculateEstimatedPaye: "Calculate estimated PAYE",
    estimatedPayeTax: "Estimated PAYE tax",
    estimatedNetPayment: "Estimated net payment",
    taxCode: "Tax Code",
    taxBasis: "Basis",
    oneOffIncomePayment: "One-off income payment",
    takeOneOffIncomePayment: "Do you wish to take a one-off income payment?",
    maximumGrossOneOffIncomePayment: "Maximum gross one-off income payment",
    capped: "Capped",
    flexi: "Flexible",
    from: "From",
    amount: "Amount",
    type: "Type",
    member: "Member",
    gadMaximum: "GAD maximum",
    incomeTakenToDate: "Income taken to date",
    lastMandatoryReview: "Last mandatory review",
    maximumIncomePaymentForRemainderOfYear: "Maximum income payment for remainder of pension year",
    maximumIncomePaymentForFutureYears: "Maximum income payment for future pension years",
    incomePerPaymentForCurrentPensionYear: "Income per payment for current pension year",
    incomePerPaymentForFuturePensionYears: "Income per payment for future pension years",
    MaximumIncomePerPayment: "Maximum income payment per payment",
    incomePerPayment: "Income per payment",
    takeFullValue: "Take Full value",
    flexiArrangementsExhausted: "Please tick to confirm your client understands this and is happy to proceed",
    paymentMethod: "Payment method",
};

export const quoteSippIncomePaymentDetailsMessages = {
    grossInitialIncomePaymentRequired: "Please enter gross initial income payment",
    grossIncomePerPaymentRequired: "Please enter gross income per payment",
    grossIncomePerPaymentFromPensionRequired: "Please enter gross income per payment from the pension",
    incomeFrequencyRequired: "Please enter income frequency",
    firstPaymentDateRequired: "Please enter first payment date",
    enterADateRequired: "Please enter a date",
    oneOffIncomePaymentRequired: "Please enter one-off income payment",
    incomePerPaymentForCurrentPensionYearRequired: "Please enter income per payment for current pension year",
    incomePerPaymentForFuturePensionYearsRequired: "Please enter income per payment for future pension years",
    incomePerPaymentRequired: "Please enter income per payment",
    flexiArrangementsExhausted:
        "The income specified will exhaust one or more of your client's flexible drawdown arrangements within a year.",
    messagesGrossInitialIncomeOver: "Gross initial income payment must not be greater than maximum",
    grossIncomePerPaymentOver:
        "Please enter an income amount that is greater than zero and less than or equal to the maximum income per payment.",
    grossAvailablePerPaymentOver:
        "Please enter an income amount that is greater than zero and less than or equal to the maximum available per payment.",
    firstPaymentDateUnder15: "The date selected must be at least 15 working days from today",
    firstPaymentDateUnder10: "The date selected must be at least 10 working days from today",
    endDateUnder: "End date must be equal to or later than the first payment date",
    dateOver28: "Date must also be between 1-28 of any month",
    grossOneOffIncomePerPaymentOver:
        "One off income payment value cannot be greater than the Maximum gross one-off income payment value",
    targetSpecificArrangementsMessage: (
        <p className="warning-message">
            For purposes of illustration, the income is assumed to be taken proportionally across all crystallised
            arrangements
        </p>
    ),
    standardAlgorithmCappedMessage:
        "Where income is being taken from Capped drawdown, the amount available will be subject to the maximum annual limits. The maximum income may be less than shown where drawdown benefits have been transferred to the Aberdeen SIPP and withdrawals have been taken from the previous scheme.",
    inheritedFundMessage:
        "This Aberdeen SIPP plan includes an inherited drawdown arrangement(s). Remember, you can use the ‘target specific arrangements’ option should you wish to include or exclude these arrangements when making withdrawals.",
};
